import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

//import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Menu from "./Menu";
import Exercise from "./Exercise";
import PageNotFound from "./PageNotFound";
import MyResults from './myResults';

export default function App(){
  console.log(window.top.location);
  const urlParams=new URLSearchParams(window.top.location.search);
  const page = urlParams.get("page");
  var allowedPages = ['menu', 'exercise'];
  if (page == null || page == 'menu') {
    return <Menu key='Menu' />;
  }
  else if (page == 'exercise') {
    return <Exercise key='Exercise' urlParams ={ urlParams } />;
  }
  else if(page == 'myResults'){
    return <MyResults key='MyResults' />
  }
  else{
    return <PageNotFound key='PageNotFound' />;
  }
  /*
  console.log()


  return(
    <BrowserRouter>
      <Routes>
      <Route path='?/' index element={<Menu />}></Route>
      <Route path={'exercise'}  element={<Exercise />}></Route>
        <Route path='*'  element={<PageNotFound />}></Route>
      </Routes>
    </BrowserRouter>
  );
  */
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App key='App' />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
